import { asuransiGadgetMeta } from "../data/DataMetatags";
import { defBreadcrumb } from "../data/DataBreadcrumb";
import Layout from "../components/Layout";
import NextHead from "../components/Seo/NextHead";
import { AsuransiGadgetBreadcrumb } from "../data/DataBreadcrumb";
import Description from "../components/UserInterface/Description";
import LayoutCenter from "../components/UserInterface/LayoutCenter";
import { ImageComponent } from "../components/UserInterface/ImageComponent";
import easyMax from "../../public/static/images/png/Claim-easymaxs.png";
import BreadcrumbComponent from "../components/UserInterface/BreadcrumbComponent";
import { NumberedText } from "../components/UserInterface/NumberedText";
import HeadingComponent from "../components/UserInterface/HeadingComponent";
import Images from "../components/UserInterface/Images";
import EasyCover from "../../public/static/images/svg/easycover.svg";
import {
  BenefitEasyMaxCover,
  KlaimEasyMaxCover,
  TableEasyMaxCover
} from "../data/DataEasyMaxCover";
import { TableComponent } from "../components/UserInterface/TableComponent";
import React from "react";

const AsuransiGadget = (props) => {
  const {
    breadcrumb,
    title,
    description,
    path,
    AsuransiGadgetBreadcrumb,
    BenefitEasyMaxCover,
    TableEasyMaxCover,
    KlaimEasyMaxCover,
  } = props;

  return (
    <Layout>
      <NextHead
        title={title}
        description={description}
        url={path}
        breadcrumb={breadcrumb}
      />
      <BreadcrumbComponent items={AsuransiGadgetBreadcrumb} />
      <ImageComponent url={EasyCover} />
      <Description
        width="820px"
        margin="12px 16px"
        font="Roboto"
        text="Lindungi Handphone, Gadget, dan Laptop kamu dari kerusakan yang tidak disengaja dengan EASYCOVER!"
      />
      <Description
        width="820px"
        margin="12px 16px"
        font="Roboto"
        text="EASYCOVER adalah produk proteksi yang diberikan untuk melindungi handphone, gadget, tablet, atau laptop akibat kerusakan fisik atau terkena cairan selama masa cicilan berlangsung. EASYCOVER akan memberikan perlindungan tambahan di luar garansi standar yang pada umumnya meliputi kerusakan mekanis yang timbul dari kesalahan pabrik."
      />
      <Description
        width="820px"
        margin="12px 16px"
        font="Roboto"
        text="Dengan EASYCOVER, kamu jadi bisa tenang terlindungi dan bebas beraktivitas sehari-hari!"
      />
      <LayoutCenter mobileDirection>
        <Images width="460px" url={easyMax} />
        <NumberedText
          withoutNumber
          data={BenefitEasyMaxCover}
          title="Manfaat EASYCOVER"
        />
      </LayoutCenter>
      <LayoutCenter column>
        <HeadingComponent headingText="Resiko yang ditanggung" />
        <TableComponent
          width1="132px"
          width2="132px"
          mobileWidth1="65px"
          mobileWidth2="65px"
          table={TableEasyMaxCover}
        />
      </LayoutCenter>
      <LayoutCenter column>
        <HeadingComponent headingText="Prosedur Klaim EASYCOVER" />
        <NumberedText data={KlaimEasyMaxCover} />
      </LayoutCenter>
      <HeadingComponent
        fontWeight="bold"
        headingText="Penyedia Jasa EASYCOVER®"
      />
      <Description
        width="820px"
        margin="32px 16px 64px 16px"
        font="Roboto"
        fontSize="16px"
        text="EASYCOVER® merupakan produk layanan perbaikan antara PT Home Credit Indonesia dengan PT Bolttech Device Protection Indonesia (bolttech), PT Mitra Jasa Pratama, dan PT Web Proteksi Solusindo dimana masing-masing perusahaan tersebut bekerjasama dengan PT Home Credit Indonesia sebagai pihak Pemasar. PT Home Credit Indonesia sebagai perusahaan pembiayaan, serta ketiga perusahaan asuransi dan pialang asuransi tersebut, berizin dan diawasi oleh Otoritas Jasa Keuangan (OJK)"
      />
    </Layout>
  );
};

export const getStaticProps = async () => {
  const { title, description, path } = asuransiGadgetMeta;

  const breadcrumb = [
    ...defBreadcrumb,
    {
      "@type": "ListItem",
      position: "2",
      item: {
        "@id": process.env.baseUrl + path,
        name: title
      }
    }
  ];

  return {
    props: {
      breadcrumb,
      title,
      description,
      path,
      AsuransiGadgetBreadcrumb,
      BenefitEasyMaxCover,
      TableEasyMaxCover,
      KlaimEasyMaxCover,
    }
  };
};

export default AsuransiGadget;
